import { __exports as s } from "./index407.mjs";
import { i as C } from "./index408.mjs";
import M from "./index409.mjs";
import N from "./index410.mjs";
var _ = C;
Object.defineProperty(s, "__esModule", {
  value: !0
});
var S = s.alpha = O;
s.blend = q;
s.colorChannel = void 0;
var F = s.darken = v;
s.decomposeColor = i;
s.emphasize = $;
var B = s.getContrastRatio = k;
s.getLuminance = h;
s.hexToRgb = y;
s.hslToRgb = E;
var P = s.lighten = c;
s.private_safeAlpha = w;
s.private_safeColorChannel = void 0;
s.private_safeDarken = j;
s.private_safeEmphasize = A;
s.private_safeLighten = I;
s.recomposeColor = o;
s.rgbToHex = V;
var m = _(M), D = _(N);
function g(e, t = 0, r = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > r) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${r}].`), (0, D.default)(e, t, r);
}
function y(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let r = e.match(t);
  return r && r[0].length === 1 && (r = r.map((n) => n + n)), r ? `rgb${r.length === 4 ? "a" : ""}(${r.map((n, a) => a < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function R(e) {
  const t = e.toString(16);
  return t.length === 1 ? `0${t}` : t;
}
function i(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return i(y(e));
  const t = e.indexOf("("), r = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(r) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, m.default)(9, e));
  let n = e.substring(t + 1, e.length - 1), a;
  if (r === "color") {
    if (n = n.split(" "), a = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(a) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${a}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, m.default)(10, a));
  } else
    n = n.split(",");
  return n = n.map((p) => parseFloat(p)), {
    type: r,
    values: n,
    colorSpace: a
  };
}
const x = (e) => {
  const t = i(e);
  return t.values.slice(0, 3).map((r, n) => t.type.indexOf("hsl") !== -1 && n !== 0 ? `${r}%` : r).join(" ");
};
s.colorChannel = x;
const T = (e, t) => {
  try {
    return x(e);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
s.private_safeColorChannel = T;
function o(e) {
  const {
    type: t,
    colorSpace: r
  } = e;
  let {
    values: n
  } = e;
  return t.indexOf("rgb") !== -1 ? n = n.map((a, p) => p < 3 ? parseInt(a, 10) : a) : t.indexOf("hsl") !== -1 && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), t.indexOf("color") !== -1 ? n = `${r} ${n.join(" ")}` : n = `${n.join(", ")}`, `${t}(${n})`;
}
function V(e) {
  if (e.indexOf("#") === 0)
    return e;
  const {
    values: t
  } = i(e);
  return `#${t.map((r, n) => R(n === 3 ? Math.round(255 * r) : r)).join("")}`;
}
function E(e) {
  e = i(e);
  const {
    values: t
  } = e, r = t[0], n = t[1] / 100, a = t[2] / 100, p = n * Math.min(a, 1 - a), u = (d, b = (d + r / 30) % 12) => a - p * Math.max(Math.min(b - 3, 9 - b, 1), -1);
  let l = "rgb";
  const f = [Math.round(u(0) * 255), Math.round(u(8) * 255), Math.round(u(4) * 255)];
  return e.type === "hsla" && (l += "a", f.push(t[3])), o({
    type: l,
    values: f
  });
}
function h(e) {
  e = i(e);
  let t = e.type === "hsl" || e.type === "hsla" ? i(E(e)).values : e.values;
  return t = t.map((r) => (e.type !== "color" && (r /= 255), r <= 0.03928 ? r / 12.92 : ((r + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function k(e, t) {
  const r = h(e), n = h(t);
  return (Math.max(r, n) + 0.05) / (Math.min(r, n) + 0.05);
}
function O(e, t) {
  return e = i(e), t = g(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, o(e);
}
function w(e, t, r) {
  try {
    return O(e, t);
  } catch {
    return r && process.env.NODE_ENV !== "production" && console.warn(r), e;
  }
}
function v(e, t) {
  if (e = i(e), t = g(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let r = 0; r < 3; r += 1)
      e.values[r] *= 1 - t;
  return o(e);
}
function j(e, t, r) {
  try {
    return v(e, t);
  } catch {
    return r && process.env.NODE_ENV !== "production" && console.warn(r), e;
  }
}
function c(e, t) {
  if (e = i(e), t = g(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (255 - e.values[r]) * t;
  else if (e.type.indexOf("color") !== -1)
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (1 - e.values[r]) * t;
  return o(e);
}
function I(e, t, r) {
  try {
    return c(e, t);
  } catch {
    return r && process.env.NODE_ENV !== "production" && console.warn(r), e;
  }
}
function $(e, t = 0.15) {
  return h(e) > 0.5 ? v(e, t) : c(e, t);
}
function A(e, t, r) {
  try {
    return $(e, t);
  } catch {
    return r && process.env.NODE_ENV !== "production" && console.warn(r), e;
  }
}
function q(e, t, r, n = 1) {
  const a = (f, d) => Math.round((f ** (1 / n) * (1 - r) + d ** (1 / n) * r) ** n), p = i(e), u = i(t), l = [a(p.values[0], u.values[0]), a(p.values[1], u.values[1]), a(p.values[2], u.values[2])];
  return o({
    type: "rgb",
    values: l
  });
}
export {
  S as alpha,
  F as darken,
  s as default,
  B as getContrastRatio,
  P as lighten
};
